import PageError from './PageErrorTheme';

export default PageError;
